<template>
  <div v-if="globalUnreadStatus" class="marker-dot"></div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"

export default {
  computed: {
    ...mapState("messages", ["globalUnreadStatus"]),

    ...mapGetters("auth", ["isAuthenticated", "currentUser"])
  },

  methods: {
    ...mapActions("messages", ["fetchGlobalUnreadStatus"]),

    fetchStatus() {
      if (this.isAuthenticated) {
        this.fetchGlobalUnreadStatus()
      }
    }
  },

  watch: {
    isAuthenticated: {
      immediate: true,
      handler: function() {
        if (this.isAuthenticated) {
          this.fetchStatus()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.marker-dot {
  background: $color-ui--green-dot;
  border: 2px solid $color-ui--white;
  position: absolute;
  top: 0.25rem;
  left: calc(50% - 1rem);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  z-index: 100;

  animation: bounce-in 1s ease-in-out;
}
</style>
